import { useConnector } from "react-instantsearch-hooks";
import connectStats from "instantsearch.js/es/connectors/stats/connectStats";
import {
  StatsConnectorParams,
  StatsRenderState,
  StatsWidgetDescription,
} from "instantsearch.js/es/connectors/stats/connectStats";

export const useStats = (props?: Record<string, unknown>): StatsRenderState => {
  return useConnector<StatsConnectorParams, StatsWidgetDescription>(connectStats, props);
};
